import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Doctors } from "./pages/Doctors";
import { DoctorProfile } from "./pages/DoctorProfile";
import { BookAppointment } from "./pages/BookAppointment";
import { Contact } from "./pages/Contact";
import { SymptomPage } from "./pages/SymptomPage";
import { SymptomsIndex } from "./pages/SymptomsIndex";
import { LegalPage } from "./pages/LegalPage";
import { SYMPTOM_PAGES } from "./data/symptomPages";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AdminLogin } from "./pages/admin/AdminLogin";
import { AdminDashboard } from "./pages/admin/AdminDashboard";
import { AdminAppointments } from "./pages/admin/AdminAppointments";

const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main id="main-content" tabIndex="-1">{children}</main>
    <Footer />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          {/* Skip-to-content link for keyboard / screen-reader users */}
          <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-[#1C5C62] focus:text-white focus:px-4 focus:py-2 focus:rounded focus:shadow-lg"
            data-testid="skip-to-content"
          >
            Skip to main content
          </a>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/doctors" element={<PublicLayout><Doctors /></PublicLayout>} />
            <Route path="/doctors/:slug" element={<PublicLayout><DoctorProfile /></PublicLayout>} />
            <Route path="/book-appointment" element={<PublicLayout><BookAppointment /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />

            {/* Symptom guides — SEO landing pages */}
            <Route path="/symptoms" element={<PublicLayout><SymptomsIndex /></PublicLayout>} />
            {SYMPTOM_PAGES.map((p) => (
              <Route key={p.slug} path={`/${p.slug}`} element={<PublicLayout><SymptomPage /></PublicLayout>} />
            ))}

            {/* Legal / Editorial pages */}
            <Route path="/privacy-policy" element={<PublicLayout><LegalPage pageKey="privacy" /></PublicLayout>} />
            <Route path="/terms-of-service" element={<PublicLayout><LegalPage pageKey="terms" /></PublicLayout>} />
            <Route path="/editorial-policy" element={<PublicLayout><LegalPage pageKey="editorial" /></PublicLayout>} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="appointments" element={<AdminAppointments />} />
            </Route>

            {/* Catch-all: unknown URL → home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
